import i18n from '@/i18n'

export default [
  {
    path: '/partners',
    component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Partners.vue'),
    meta: {
      noContextRequired: true
    },
    children: [
      {
        path: '',
        name: 'partnersOverview',
        component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Overview/PartnersOverview.vue'),
        meta: {
          permissions: ['Mapi.Partners.Read'],
          menu: {
            index: 150,
            routeName: 'partnersOverview',
            activeWhen: ['partnersOverview', 'partnerDetail'],
            title: i18n.t('label.partners'),
            icon: ['fal', 'handshake']
          }
        }
      },
      {
        path: ':partnerId',
        name: 'partnerDetail',
        component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Detail/PartnerDetail.vue'),
        meta: {
          permissions: ['Mapi.Partner.Read'],
          menu: {
            index: 150,
            routeName: 'partnerDetail',
            routeParams: context => ({ 'partnerId': context.partner.id }),
            activeWhen: ['partnerDetail'],
            title: i18n.t('label.partner'),
            icon: ['fal', 'handshake'],
            canShow: ({ context }) => context.isSelected('partner')
          }
        },
        props: true
      },
      {
        path: ':partnerId/users/add',
        name: 'addPartnerUser',
        component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Detail/User/Detail/PartnerUserDetail.vue'),
        props: (route) => ({ ...route.params, userId: null }),
        meta: {
          permissions: ['Mapi.Users.Read', 'Mapi.Users.Create']
        }
      },
      {
        path: ':partnerId/users/:userId',
        name: 'partnerUserDetail',
        component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Detail/User/Detail/PartnerUserDetail.vue'),
        meta: {
          permissions: ['Mapi.Users.Read']
        },
        props: true
      },
      {
        path: ':partnerId/commissions/:commissionPlanId',
        name: 'partnerCommissionPlanDetail',
        component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Detail/CommissionPlan/Detail/PartnerCommissionPlanDetail.vue'),
        meta: {
          permissions: ['Mapi.Partner.Read']
        },
        props: true
      },
      {
        path: ':partnerId/declines',
        name: 'partnerDeclineOverview',
        component: () => import(/* webpackChunkName: "Partners" */ '@/views/Partners/Detail/Decline/Overview/PartnerDeclineOverview.vue'),
        meta: {
          permissions: ['Mapi.Partner.Read']
        },
        props: true
      },
      {
        path: ':partnerId/transactions',
        name: 'partnerTransactionsOverview',
        component: () => import(/* webpackChunkName: "PartnersTransactions" */ '@/views/Partners/Overview/PartnersTransactionsOverview.vue'),
        meta: {
          permissions: ['Mapi.Transactions.Read']
        },
        props: true
      },
      {
        path: ':partnerId/business/:businessId',
        name: 'partnerBusinessDetail',
        component: () => import(/* webpackChunkName: "BusinessDetail" */ '@/views/Partners/Detail/Business/Detail/PartnerBusinessDetail.vue'),
        meta: {
          permissions: ['Mapi.Business.Read']
        },
        props: true
      },
      {
        path: ':partnerId/business/:businessId/merchant/:merchantId',
        name: 'partnerMerchantDetail',
        component: () => import(/* webpackChunkName: "MerchantDetail" */ '@/views/Partners/Detail/Business/Detail/PartnerMerchantDetail.vue'),
        meta: {
          permissions: ['Mapi.Merchant.Read']
        },
        props: true
      },
      {
        path: ':partnerId/business/:businessId/transactions',
        name: 'partnerBusinessTransactionsOverview',
        component: () => import(/* webpackChunkName: "PartnersTransactions" */ '@/views/Partners/Overview/PartnersTransactionsOverview.vue'),
        meta: {
          permissions: ['Mapi.Transactions.Read']
        },
        props: true
      }
    ]
  }
]
